// extracted by mini-css-extract-plugin
export var bounce = "_l6-1";
export var generatingText = "_l6-6";
export var lightning = "_l6-4";
export var popup = "_l6-5";
export var progressBar = "_l6-7";
export var progressFill = "_l6-8";
export var progressShimmer = "_l6-9";
export var progressText = "_l6-a";
export var shimmer = "_l6-3";
export var uploadIcon = "_l6-0";
export var uploadingText = "_l6-2";